export default "__VITE_ASSET__6FZledplxBd88wbbVe1skw__"